import React from "react";
import { Popover, Tag, Space } from "antd";
import { BranchesOutlined } from "@ant-design/icons";
import StockFL from "../FormatStock";

const StockBreakdown = ({
    totalStock = 0,
    breakdown = [],
    conversion = 1,
}) => {
    const branchCount = breakdown?.length || 0;
    const stopClick = (e) => e.stopPropagation();

    // Always use StockFL for consistent full/loose display
    const formatStock = (stock) => (
        <StockFL totalStock={stock} conversion={conversion} />
    );

    const content = (
        <div className="w-64 p-3">
            {/* Branch list */}
            <div className="space-y-3">
                {breakdown.map((b) => (
                    <div key={b.branchId} className="flex items-center justify-between py-1">
                        <span className="text-sm font-medium text-gray-700 truncate max-w-[140px]">
                            {b.branchName}
                        </span>
                        <div className="text-right min-w-[80px]">
                            {formatStock(b.stock)}
                        </div>
                    </div>
                ))}
            </div>

            {/* Divider */}
            <div className="border-t my-3" />

            {/* Total */}
            <div className="flex items-center justify-between text-sm font-bold bg-gray-50 p-2 rounded-lg">
                <span className="text-gray-800">Total Inventory</span>
                <div className="text-right min-w-[80px]">
                    {formatStock(totalStock)}
                </div>
            </div>
        </div>
    );

    return (
        <div onClick={stopClick} className="w-full h-full flex items-center justify-center">
            <Popover
                content={content}
                trigger="click"
                placement="rightTop"
                title={
                    <div className="flex items-center gap-2 text-sm font-semibold text-gray-700">
                        <BranchesOutlined />
                        Stock by Branch
                    </div>
                }
            >
                <Space className="cursor-pointer hover:bg-blue-50 px-2 py-1 rounded-lg transition-all group">
                    {/* Main display - uses StockFL */}
                    <span className="font-bold text-lg group-hover:text-blue-700 whitespace-nowrap">
                        {formatStock(totalStock)}
                    </span>

                    {/* Branch indicator */}
                    {branchCount > 1 && (
                        <Tag
                            color="cyan"
                            className="text-xs font-medium flex items-center gap-1 px-2 py-1"
                        >
                            <BranchesOutlined style={{ fontSize: 10 }} />
                            {branchCount}
                        </Tag>
                    )}
                </Space>
            </Popover>
        </div>
    );
};

export default StockBreakdown;